import React, { useMemo, useState } from 'react';
import { alpha } from "@mui/material/styles";

import { makeStyles } from '@material-ui/core/styles';
import Radio from '@mui/material/Radio';
import { Box, Paper } from '@mui/material';
import { canMonitor, isAnalista } from "../commons/utils";
import ListTramites from './ListTramites';
import { IconButton } from '@mui/material';
import { InputBase } from '@mui/material';
import Search from '@mui/icons-material/Search';

import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({


    toolbarsearch: {

        width: '90%',
        margin: '0 auto',
        maxWidth: '1100px',
        marginTop: 24
    },
    textHelpSearch: {

        textAlign: "center",
        paddingLeft: 10,
        fontSize: 14,
        color: "#040404"

    },

    backSuper: {
        background: "url(https://rnpi.superdesalud.gob.cl/app/images/3.png) no-repeat center center fixed",

        backgroundSize: "cover"
    },



    /* '@media screen and (min-width: 700px)': {
        toolbarsearch: {
            display: 'block',
        },
        
      }, */
    grow: {
        flexGrow: 1
    },
    menuButton: {
        marginRight: theme.spacing(2)
    },
    title: {
        display: "none",
        [theme.breakpoints.up("sm")]: {
            display: "block"
        },

    },
    search: {
        position: "relative",
        borderRadius: theme.shape.borderRadius,

        "&:hover": {
            backgroundColor: alpha(theme.palette.common.white, 0.25)
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            marginLeft: theme.spacing(3),
            width: "auto"
        },
        backgroundColor: "#0064AC"
    },

    searchIcon: {
        padding: theme.spacing(0, 2),
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    inputRoot: {
        color: "inherit"
    },

    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("md")]: {
            width: "20ch"
        }
    },
    sectionDesktop: {
        display: "none",
        [theme.breakpoints.up("md")]: {
            display: "flex"
        }
    },
    sectionMobile: {
        display: "flex",
        marginTop: "10px",
        [theme.breakpoints.up("md")]: {
            display: "none"
        }
    },
    //   inputSearch: {
    //     backgroundColor: "#d5d5d5 !important",
    // }
    root2: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: "100%",
        backgroundColor: '#fafafa'

    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 15,
    },
    divider: {
        height: 28,
        margin: 4,
    },
}));

const ListTramitesIndex = props => {

    const history = useHistory();
    const [selectedValue, setSelectedValue] = useState('rut');

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };
    const classes = useStyles();
    const { user, userLoggedIn } = props;

    // const [search, setSearch] = useState({ wildcard: undefined, rut: (user || {}).rut });
    const [search, setSearch] = useState('');
    const [timeoutId, setIdTimeout] = useState({ wildcard: undefined });
    const { innerWidth: width/*, innerHeight: height*/ } = window;
    const [searchNow, setSearchNow] = useState(false)


    //const listTramitesRender = useMemo(() => <ListTramites {...{ ...props, ...search, userLoggedIn }} />, [props, search.rut, search.wildcard]) 
    /*   const listTramitesRender = useMemo(() => <ListTramites {...{ ...props, userLoggedIn }} rut={user.rut} wildcard={search} type={selectedValue} />) */

    const handleChangeSearch = evt => {

        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        const id = setTimeout(() => setSearch(evt.target.value), 1000);
        setIdTimeout(id)

    }


    const clickSearch = () => {
        setSearchNow(!searchNow)
    }

    return (


        <div className={classes.backSuper}>
            <div className={classes.toolbarsearch}>


                {!isAnalista((user || {}).auth) ?
                    null
                    :
                    /*  width > 500 ? */

                    <Box style={{ marginBottom: 10 }}>

                        {canMonitor(user) ?
                            <Grid container>
                                <Grid container item xs={12}>
                                    <Grid container item xs={6}>
                                        <Grid style={{ cursor: 'pointer', marginRight: 2 }} onClick={() => { history.push('/listreclamo') }}>
                                            <p style={{ fontWeight: 'bold', color: 'blue', textDecoration: 'underline' }}>Seguimiento</p>
                                        </Grid>
                                        <Grid>
                                            <p>/</p>
                                        </Grid>
                                        <Grid style={{ cursor: 'pointer', marginLeft: 2, marginRight: 2 }} onClick={() => { history.push('/monitoreo') }}>
                                            <p>Monitoreados</p>
                                        </Grid>
                                        <Grid>
                                            <p>/</p>
                                        </Grid>
                                        <Grid style={{ cursor: 'pointer', marginLeft: 2, marginRight: 2 }} onClick={() => { history.push('/movimientos') }}>
                                            <p>Movimientos</p>
                                        </Grid>
                                        <Grid>
                                            <p>/</p>
                                        </Grid>
                                        <Grid style={{ cursor: 'pointer', marginLeft: 2 }} onClick={() => { history.push('/historia') }} >
                                            <p >Histórico</p>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                            :
                            null
                        }

                        {width > 500 ?
                            <div style={{ marginBottom: 10 }}>
                                Buscar por:
                                <Radio
                                    checked={selectedValue === 'rut'}
                                    onChange={handleChange}
                                    value="rut"
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'rut' }}
                                /> RUN (12345678-9)
                                <Radio
                                    checked={selectedValue === 'folio'}
                                    onChange={handleChange}
                                    value="folio"
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'folio' }}
                                /> Fólio

                                <Radio
                                    checked={selectedValue === 'name'}
                                    onChange={handleChange}
                                    value="name"
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'name' }}
                                /> Nombre y/o Apellido
                            </div>
                            :
                            <div style={{ marginBottom: 10 }}>

                                <FormControl style={{ width: '100%' }}>
                                    <FormLabel style={{ fontWeight: 'bold', marginTop: 5, color: 'black' }}>Buscar por</FormLabel>
                                    <RadioGroup
                                        style={{ margin: 10, }}
                                    >
                                        <div style={{ height: 1, backgroundColor: '#cccccc' }}></div>
                                        <FormControlLabel value="rut" control={<Radio
                                            checked={selectedValue === 'rut'}
                                            onChange={handleChange} />} label="RUN (12345678-9)" />
                                        <div style={{ height: 1, backgroundColor: '#cccccc' }}></div>
                                        <FormControlLabel value="folio" control={<Radio
                                            checked={selectedValue === 'folio'}
                                            onChange={handleChange}
                                        />} label="Fólio" />
                                        <div style={{ height: 1, backgroundColor: '#cccccc' }}></div>
                                        <FormControlLabel value="name" control={<Radio
                                            checked={selectedValue === 'name'}
                                            onChange={handleChange}
                                        />} label="Nombre / Apellido" />
                                        <div style={{ height: 1, backgroundColor: '#cccccc' }}></div>
                                    </RadioGroup>
                                </FormControl>

                            </div>
                        }

                        <Paper style={{ marginBottom: 10 }}>

                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Buscar"

                                style={{ width: '80%' }}
                                value={search.wildcard}

                                onChange={handleChangeSearch}

                            />
                            <IconButton type="submit" sx={{ p: '10px' }} aria-label="search" onClick={clickSearch}>
                                <Search />
                            </IconButton>
                        </Paper>
                        <ListTramites {...{ ...props, userLoggedIn }} rut={user.rut} wildcard={search} type={selectedValue} searchNow={searchNow} />
                    </Box>
                }

                {/*    {listTramitesRender} */}

            </div>

        </div>
    );
}

export default ListTramitesIndex;
